import UserMappingPage from "./UserMappingPage";

export default function UserMapping() {
  return <UserMappingPage />;
}